// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgDownload24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.75 4C12.75 3.58579 12.4142 3.25 12 3.25C11.5858 3.25 11.25 3.58579 11.25 4V14.189L8.53033 11.4697C8.23744 11.1768 7.76256 11.1768 7.46967 11.4697C7.17678 11.7626 7.17678 12.2374 7.46967 12.5303L11.4697 16.5303L11.5486 16.599L11.631 16.6531L11.7019 16.6884L11.7607 16.711L11.8286 16.7303L11.9305 16.7468L12 16.75L12.0515 16.7482L12.1363 16.7376L12.2387 16.7112L12.3252 16.6761L12.42 16.6215L12.46 16.591L12.5303 16.5303L16.5303 12.5303C16.8232 12.2374 16.8232 11.7626 16.5303 11.4697L16.4462 11.3971C16.1526 11.1792 15.7359 11.2034 15.4697 11.4697L12.75 14.189V4ZM21 15.75C21 15.3358 20.6642 15 20.25 15L20.1482 15.0068C19.7822 15.0565 19.5 15.3703 19.5 15.75V19C19.5 19.2761 19.2761 19.5 19 19.5H5C4.72386 19.5 4.5 19.2761 4.5 19V15.75C4.5 15.3358 4.16421 15 3.75 15L3.64823 15.0068C3.28215 15.0565 3 15.3703 3 15.75V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V15.75Z"
				/>
			</Svg>
		);
	}
);
SvgDownload24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgDownload24;
